import { render, staticRenderFns } from "./radio-button.vue?vue&type=template&id=49a81380&"
import script from "./radio-button.vue?vue&type=script&lang=js&"
export * from "./radio-button.vue?vue&type=script&lang=js&"
import style0 from "./radio-button.vue?vue&type=style&index=0&id=49a81380&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports